module.exports = __webpack_public_path__ + "static/pulau-derawan-4df3e0517e70d02c1621c0827ff8a74b.png";